import React, { useCallback } from 'react';

/**
 * ClickableTypePicker
 * - UX helper buat admin biar bisa pilih `clickable_type` via click (tanpa dropdown)
 * - Mengembalikan shape yang sama dengan react-select: `{ value, label }` atau `null` (clear)
 */
export default function ClickableTypePicker(props) {
  const { value, options, onChange, isDisabled } = props;

  const handlePick = useCallback((option) => {
    if (isDisabled) return;

    // UX: click lagi pada item yang sama = clear (mirip isClearable di react-select)
    if (value && option?.value === value) {
      onChange?.(null);
      return;
    }

    onChange?.(option);
  }, [isDisabled, onChange, value]);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
      {(Array.isArray(options) ? options : []).map((option) => {
        const isActive = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => handlePick(option)}
            disabled={isDisabled}
            aria-pressed={isActive}
            className={isActive ? 'btn btn-primary btn-sm' : 'btn btn-outline-primary btn-sm'}
            style={{
              minWidth: 140,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
            title={isActive ? 'Klik untuk clear' : `Pilih ${option.label}`}
          >
            {/* Intentional: text-only, preview tetap via Modal di ClickableSection */}
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
